import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    headerWrapper: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerInputContainer: {
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center"
    },
    companyCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    companyContent: {
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        flexShrink: 1
    },
    companyNavigation: {
        justifyContent: "flex-start",
        alignSelf: "flex-start"
    },
    memberCardContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    memberCardContent: {
        flex: 1,
        flexDirection: "column",
        alignItems: "flex-start",
        flexShrink: 1
    },
    memberCardNavigation: {
        justifyContent: "center",
        alignSelf: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        left: 0,
        right: 0
    },
    headerTitle: {
        alignSelf: "center"
    },
    notFoundContainer: {
        alignContent: "center",
        justifyContent: "center"
    },
    textCenter: {
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    }
});
export default stylesheet;
